import { gsap } from "gsap";

document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.shipping-progress-bar-wrapper');
    const content = document.querySelector('.shipping-progress-bar-content');
    
    if (!wrapper || !content) return;

    let tl;
    let originalContent;

    function initializeAnimation() {
        const isMobile = window.innerWidth < 768;
        
        // Rimuovi sempre l'animazione esistente
        if (tl) {
            tl.kill();
            gsap.set(wrapper, { clearProps: "all" });
        }

        if (isMobile) {
            // Salva il contenuto originale se non l'abbiamo già fatto
            if (!originalContent) {
                originalContent = content.cloneNode(true);
            }

            // Rimuovi eventuali cloni esistenti
            wrapper.innerHTML = '';
            wrapper.appendChild(content);

            // Duplica il contenuto più volte
            const duplications = 4;
            for (let i = 0; i < duplications; i++) {
                wrapper.appendChild(content.cloneNode(true));
            }

            // Imposta la larghezza del wrapper
            const totalWidth = content.offsetWidth * (duplications + 1);
            gsap.set(wrapper, { width: totalWidth });

            // Animazione di scorrimento
            tl = gsap.timeline({ repeat: -1 });
            tl.to(wrapper, {
                x: -content.offsetWidth,
                duration: 20,
                ease: "linear",
                modifiers: {
                    x: gsap.utils.unitize(x => parseFloat(x) % (-content.offsetWidth))
                }
            });
        } else {
            // Ripristina lo stato originale per desktop
            wrapper.innerHTML = '';
            wrapper.appendChild(originalContent ? originalContent.cloneNode(true) : content);
            gsap.set(wrapper, { width: "auto" });
        }
    }

    // Inizializza l'animazione al caricamento
    initializeAnimation();

    // Aggiorna l'animazione quando la finestra viene ridimensionata
    window.addEventListener('resize', initializeAnimation);
});
